export enum JackpotAssetType {
  MAFIA_TOKEN = 0,
  IN_GAME_CASH = 1,
  HELPER_CREDIT = 2,
  PERK_BOX = 3,
  OG_CRATE = 4,
  INVENTORY_ITEM = 5,
}

export enum JackpotRoundState {
  WAITING, // no player
  STARTED, // only one player, waiting for other one
  LIVE, // started with more than 2 players
  CALCULATING_WINNER, // calculating winner
}
